import { render, staticRenderFns } from "./EstimateListHeader.vue?vue&type=template&id=58d19944&scoped=true"
import script from "./EstimateListHeader.vue?vue&type=script&lang=ts"
export * from "./EstimateListHeader.vue?vue&type=script&lang=ts"
import style0 from "./EstimateListHeader.vue?vue&type=style&index=0&id=58d19944&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d19944",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d19944')) {
      api.createRecord('58d19944', component.options)
    } else {
      api.reload('58d19944', component.options)
    }
    module.hot.accept("./EstimateListHeader.vue?vue&type=template&id=58d19944&scoped=true", function () {
      api.rerender('58d19944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/client-portal/EstimateListHeader.vue"
export default component.exports